import { Button, Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useState } from "react";
import axios from 'axios';
import config from '@/utils/config';
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";

// 线上18地址 fly：74  张：200

// 创建一个 axios 实例
const http = axios.create({
  baseURL: config.baseURL,
  //baseURL: '/api',//设置基础URL  本地走setupProxy代理  线上配nginx方向代理
  timeout:150000,//设置请求超时
  headers: {
    'Content-Type': 'application/json', 
    'Access-Control-Allow-Origin': '*', 
  },
  withCredentials: true
});
// POST 请求封装
export const postRequest = (url, data) => {
  return http.post(url, data);
};

// PUT 请求封装
export const putRequest = (url, data) => {
  return http.put(url, data);
};

// DELETE 请求封装
export const deleteRequest = (url) => {
  return http.delete(url);
};

let requestController = new AbortController();
let currentToken = localStorage.getItem("tokenPC");
const permissionState = window.__PERMISSION_STATE__ || {
  handling: false,
  modal: null,
};

window.__PERMISSION_STATE__ = permissionState;

const cancelAllRequests = () => {
  requestController.abort();
  requestController = new AbortController();
};

const ModalButton = (props) => {
  const [loading, setLoading] = useState(false);

  const clickFn = async () => {
    if (!props.buttonLoading) {
      props.clickFn();
      return;
    }
    setLoading(true);
    try {
      await props.clickFn();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button type="primary" loading={loading} onClick={clickFn}>
      OK
    </Button>
  );
};
// 请求拦截器（可选）
http.interceptors.request.use(
  (config) => {
    if (permissionState.handling && config.url !== api.restToken) {
      return Promise.reject(
        new axios.Cancel("Permission is refreshing")
      );
    }
    currentToken = localStorage.getItem("tokenPC");
    if (currentToken && currentToken !== "null") {
      config.headers = config.headers || {};
      config.headers["Authorization"] = currentToken;
    }
    config.signal = requestController.signal;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const modalTypeFn = (props) => {
  return Modal.confirm({
      title: '',
      icon: <ExclamationCircleOutlined />,
      content: props.content,
      footer: [
        <div style={{ marginTop: '10px', textAlign: 'right' }}>
          <ModalButton {...props} />
        </div>
      ],
      style: {
        top: '40%',
      },
    })
}

// 响应拦截器（可选）
const responseBeforeFn = (result) => {
  if (result?.code == "4") {
    if (permissionState.handling) {
      return;
    }
    permissionState.handling = true;
      cancelAllRequests();
    localStorage.clear();
    if (!permissionState.modal) {
      permissionState.modal = modalTypeFn({
      content: result?.data || 'Token is invalid or expired, please log in again!',
      clickFn: () => (
        permissionState.modal?.destroy(),
        permissionState.modal = null,
        permissionState.handling = false,
        localStorage.setItem('oldHref', window.location.href),
        window.location.href = `${window.location.origin}#/login`),
    })
    }
    return;
  }
  if(result?.code == '5'){
    modalTypeFn({
      content: 'The current request has been submitted. Please try again!',
      clickFn: () => window.location.reload(),
    })
    return;
  }
  if (result?.code == "6") {
    if (permissionState.handling) {
      return;
    }
    permissionState.handling = true;
    cancelAllRequests();
    if (permissionState.modal) {
      return;
    }
    permissionState.modal = modalTypeFn({
      content: result?.msg || 'Permission has been changed!',
        buttonLoading: true,
        clickFn: async () => {
          try {
            const tokenData = await http.get(api.restToken)
            await commonFn.initLoginDataFn(
              tokenData?.data,
              true
            );
            requestController = new AbortController();
          } finally {
            permissionState.handling = false;
            permissionState.modal?.destroy();
            permissionState.modal = null;
          }
        },
      });
    return;
  }
  if(result?.code == '7'){
    commonFn.closeBrowserTabFn()
    return;
  }
  if (result?.code == "9" && !permissionState.modal) {
    permissionState.modal = modalTypeFn({
      content: result?.msg || 'Do not have the permission. Please contact the administrator.',
      clickFn: () => {
        permissionState.modal?.destroy();
        permissionState.modal = null;
      },
    });
  }
};
http.interceptors.response.use(
  (response) => {
    responseBeforeFn(response.data);
    return response.data;
  },
  (error) => {
    const status = error.response ? error.response.status : error.status;
    if (status === 401) {
      const currentHash = window.location.hash.slice(1) || '/'; // 例如 "/order/detail?id=1"
      if (
        currentHash &&
        !currentHash.startsWith('/login') &&
        !currentHash.startsWith('/Nopermission')
      ) {
        // 用 sessionStorage，避免旧值长期残留
        sessionStorage.setItem('redirectPath', currentHash);
      }
      localStorage.removeItem('token');

      const loginHash = `/login?redirect=${encodeURIComponent(currentHash)}`;
   
      window.location.hash = loginHash;
    }
    if (axios.isCancel(error) || error?.code === "ERR_CANCELED") {
      return Promise.resolve({});
    }
    return Promise.reject(error);
  }
);



export default http;
